module.exports = __webpack_public_path__ + "static/media/harvest.dfa55758.png";